import { Tag } from 'client/types/tag';
import * as types from './types';

export function fetchTagRequest(slug: string): types.FetchTagRequest {
    return { type: types.FETCH_TAG_REQUEST, payload: slug };
}

export function fetchTagSuccess(data: Tag): types.FetchTagSuccess {
    return { type: types.FETCH_TAG_SUCCESS, payload: data };
}

export function fetchTagError(error: Error): types.FetchTagError {
    return { type: types.FETCH_TAG_ERROR, payload: error.message };
}
